import {css, cx} from "@emotion/css";
import $ from "jquery";
import {Dispatch, useEffect, useRef, useState} from "react";

import "@/components/ads/SkyscraperAdComponentStyles.scss";
import React from "react";
import { isNotUndefined, isNotUndefinedOrNull, showGoogleAds } from "@/shared/FunctionCore";
import {useGoogleAdAvailability} from '@/components/ads/googleAdsAvailability';

interface SkyscraperAdData {
    "adDivId": string;
    "adSize": string;
    "adUnitPath": string;
}

type SkyscraperAdDataWithAdSizeParsed = SkyscraperAdData & {
    "height": number;
    "heightWidthClassName": string;
    "width": number;
};

interface SkyscraperAdProperties {
    "hide": boolean;
    "index": number;
    "onHeightUpdate": Dispatch<number>;
    "skyscraperAdDataWithAdSizeParsed": SkyscraperAdDataWithAdSizeParsed;
    "windowGoogletag": any;
}

const getWindowGoogletag = () => window["googletag"];

const getSkyscraperAdDataWithAdSizeParsed = (googleAdsData) => {
    const windowElement = getWindowGoogletag();

    const windowGoogletag = isNotUndefined(windowElement) ? windowElement : {"cmd": []};

    const skyscraperAdDataWithAdSizeParsedArray = googleAdsData.data.skyscraperAdData.map((sk) => {
        const adSizeParsed = window.JSON.parse(sk.adSize);

        const height: number = adSizeParsed[1];
        const width: number = adSizeParsed[0];

        const skyscraperAdDataWithAdSizeParsed: SkyscraperAdDataWithAdSizeParsed = {
            ...sk,
            "height": height,
            "heightWidthClassName": css({
                "height": `${height}px`,
                "width": `${width}px`,
            }),
            "width": width,
        };

        return skyscraperAdDataWithAdSizeParsed;
    });

    return skyscraperAdDataWithAdSizeParsedArray;
}

const SkyscraperAd = (properties: SkyscraperAdProperties) => {
    const referenceObject = useRef<HTMLDivElement>(null);
    const addDefaultTop = 155;

    const hide = properties.hide;
    const skyscraperAdDataWithAdSizeParsed = properties.skyscraperAdDataWithAdSizeParsed;

    const height = skyscraperAdDataWithAdSizeParsed.height;

    const adDivId = skyscraperAdDataWithAdSizeParsed.adDivId;

    const isAdLeft = properties.index % 2 === 0;

    const [notOverlappingWithDrift, setNotOverlappingWithDrift] = useState(false);
    const [topPosition, setTopPosition] = useState(addDefaultTop);
    const [showAdd, setShowAdd] = useState(false);
    const [addTriggered, setAddTriggered] = useState(false);

    useEffect(() => {
        const bootomSpace = isAdLeft ? 50 : 150;
        if (isNotUndefinedOrNull(referenceObject.current)) {
            const determineAndSetNotOverlappingWithDrift = () => setNotOverlappingWithDrift(isNotUndefinedOrNull(referenceObject.current) && referenceObject.current.getBoundingClientRect().top + height < window.innerHeight - bootomSpace);
            $(window).on("resize", determineAndSetNotOverlappingWithDrift).on("scroll", determineAndSetNotOverlappingWithDrift);
            determineAndSetNotOverlappingWithDrift();
        }

        if (window.innerWidth >= 1200) {
            $(window).on("scroll", () => {
                const element = $(".companyAnchorsComponent.fixed");
                if (isNotUndefined(element)) {
                    const elementTop = window.Number.parseInt(element.css("top"));
                    if (topPosition !== elementTop) {
                        if (elementTop > 0) {
                            setTopPosition(addDefaultTop + elementTop);
                        } else {
                            setTopPosition(addDefaultTop);
                        }
                    }

                }
            });
        }
    }, []);


    useEffect(() => {
        if (notOverlappingWithDrift) {
            setShowAdd(true);
        }
    }, [notOverlappingWithDrift]);

    useEffect(() => {
        if (!hide && showAdd && !addTriggered) {
            properties.windowGoogletag.cmd.push(() => {
                const newWindowGoogletag = getWindowGoogletag();

                const pubads = newWindowGoogletag.pubads();

                newWindowGoogletag.defineSlot(skyscraperAdDataWithAdSizeParsed.adUnitPath, [skyscraperAdDataWithAdSizeParsed.width, height], adDivId).addService(pubads);

                pubads.enableSingleRequest();
                pubads.enableLazyLoad();

                newWindowGoogletag.enableServices();

                newWindowGoogletag.display(adDivId);
                setAddTriggered(true);
            });
            const bottomContainer = $(".add-break-section");
            const offset = bottomContainer.offset();
            if (isNotUndefined(offset)) {
                properties.onHeightUpdate(offset.top - 800);
            }
        }
    }, [hide, showAdd]);

    return <div
        className={`skyscraperAd isAdLeft-${isAdLeft} notOverlappingWithDrift-${notOverlappingWithDrift} ${skyscraperAdDataWithAdSizeParsed.heightWidthClassName}`}
        id={adDivId}
        ref={referenceObject}
        style={{"top": topPosition}} />;
};

interface SkyscraperAdComponentProperties {
    "skyscraperAdDataWithAdSizeParsedArray": SkyscraperAdDataWithAdSizeParsed[];
    "windowGoogletag": any;
}

const SkyscraperAds = (properties: SkyscraperAdComponentProperties) => {
    const [hide, setHide] = useState(true);
    const [height, setHeight] = useState(6000);

    const onHeightUpdate = (evnt: number) => {
        setHeight(evnt);
    };

    useEffect(() => {
        const mediaQueryList = window.matchMedia("(max-width: 1199px)");

        const set = (me: MediaQueryList | MediaQueryListEvent, listener: (me: MediaQueryListEvent) => void, outsideListener: boolean) => {
            if (me.matches) {
                if (outsideListener) {
                    mediaQueryList.addEventListener("change", listener);
                }
            } else {
                setHide(false);

                mediaQueryList.removeEventListener("change", listener);
            }
        };

        const listener = (me: MediaQueryListEvent) => set(me, listener, false);

        set(mediaQueryList, listener, true);
    }, []);

    return (
        <div
            className={"skyscraperParent"}
            style={{"height": height}}>
            <div className={"skyscraperContent"}>
                {properties.skyscraperAdDataWithAdSizeParsedArray.map((skyscraperAdDataWithAdSizeParsed, index) => (
                    <SkyscraperAd
                        hide={hide}
                        index={index}
                        key={index}
                        onHeightUpdate={onHeightUpdate}
                        skyscraperAdDataWithAdSizeParsed={skyscraperAdDataWithAdSizeParsed}
                        windowGoogletag={properties.windowGoogletag} />
                ))}
            </div>
        </div>
    );
};

const SkyscraperAdComponent = ({googleAdsData}) => {
    const skyscraperAdDataWithAdSizeParsedArray = getSkyscraperAdDataWithAdSizeParsed(googleAdsData);
    const [advertisingConsentGiven, setAdvertisingConsentGiven] = useState(false);
    const [windowGoogletag, setWindowGoogletag] = useState(false);
    const addAvailable = useGoogleAdAvailability();

    useEffect(() => {

        const displayAds = () => {
            if (showGoogleAds()) {
                setAdvertisingConsentGiven(true);
                const windowElement = getWindowGoogletag();
                const windowGoogletagRef = isNotUndefined(windowElement) ? windowElement : {"cmd": []};
                setWindowGoogletag(windowGoogletagRef);
            }
        };
        if (addAvailable) {
            displayAds();
        }
    }, [addAvailable]);

    return (
        !advertisingConsentGiven
            ? <></>
            : <SkyscraperAds
                skyscraperAdDataWithAdSizeParsedArray={skyscraperAdDataWithAdSizeParsedArray}
                windowGoogletag={windowGoogletag} />
    );
};

interface SkyscraperAdComponentParameter {
    "skyscraperAdData": SkyscraperAdData[];
}

// const skyscraperAdComponent = (renderableData: RenderableData<SkyscraperAdComponentParameter>): void => {
    // const windowElement = getWindowGoogletag();

    // const windowGoogletag = isNotUndefined(windowElement) ? windowElement : {"cmd": []};

    // const skyscraperAdDataWithAdSizeParsedArray = googleAdsData.data.skyscraperAdData.map((sk) => {
    //     const adSizeParsed = window.JSON.parse(sk.adSize);

    //     const height: number = adSizeParsed[1];
    //     const width: number = adSizeParsed[0];

    //     const skyscraperAdDataWithAdSizeParsed: SkyscraperAdDataWithAdSizeParsed = {
    //         ...sk,
    //         "height": height,
    //         "heightWidthClassName": css({
    //             "height": `${height}px`,
    //             "width": `${width}px`,
    //         }),
    //         "width": width,
    //     };

    //     return skyscraperAdDataWithAdSizeParsed;
    // });

    // renderIdentifierGeneric(
    //     SkyscraperAdComponent,
    //     addToRenderableData(
    //         renderableData,
    //         {
    //             "skyscraperAdDataWithAdSizeParsedArray": skyscraperAdDataWithAdSizeParsedArray,
    //             "windowGoogletag": windowGoogletag
    //         }
    //     ));
// };

// export {skyscraperAdComponent};

export default SkyscraperAdComponent;
